import React from 'react';
import { motion } from 'framer-motion';

export default function SkeletonLoader() {
  return (
    <div className="flex flex-col gap-6">
      {[1, 2, 3].map((i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-white dark:bg-[#121214] border border-slate-100 dark:border-slate-800 rounded-[24px] p-6 shadow-sm"
        >
          <div className="flex justify-between items-center mb-5">
            <div className="w-20 h-6 rounded-full bg-slate-100 dark:bg-slate-800 animate-pulse" />
            <div className="w-16 h-4 rounded bg-slate-100 dark:bg-slate-800 animate-pulse" />
          </div>
          <div className="space-y-3 mb-8">
            <div className="w-full h-5 bg-slate-100 dark:bg-slate-800 rounded animate-pulse" />
            <div className="w-5/6 h-5 bg-slate-100 dark:bg-slate-800 rounded animate-pulse" />
          </div>
          <div className="flex justify-between items-center">
            <div className="flex gap-2">
              <div className="w-12 h-8 rounded-full bg-slate-100 dark:bg-slate-800 animate-pulse" />
              <div className="w-12 h-8 rounded-full bg-slate-100 dark:bg-slate-800 animate-pulse" />
            </div>
            <div className="w-10 h-8 rounded-full bg-slate-100 dark:bg-slate-800 animate-pulse" />
          </div>
        </motion.div>
      ))}
    </div>
  );
}
